/*
  BROOT quick-order — W4 28 Sep 2026, reworked by W12 29 Sep 2026.

  Loaded only on index / collection / product / search templates (see
  layout/theme.liquid). Self-contained: no dependency on any other BROOT script.
  It never adds to the cart itself — every Add button on the site is a real,
  server-rendered <product-form> handled by the theme's own product-form.js.

  1. Card chooser (snippets/product-card.liquid). The card's Add button already
     carries the default variant (250 g Whole Bean, or the nearest purchasable
     one), so one tap adds it with no JS from this file. Only when someone taps
     the small "grind / size" link do we open the chooser: a native <dialog>
     (bottom sheet on phones, small panel on wider screens) holding the chips
     and its own Add button. It reads a small JSON of the product's variants
     that the card renders server-side (id, option values, formatted price,
     purchasable flag — the same in-stock test as snippets/broot-instock.liquid),
     so opening it costs no network request, and the sold-out combinations are
     greyed out for real. A chip tap resolves to a variant (moving the other
     option to the nearest purchasable one if the exact combination is sold
     out), points the hidden `id` input at it and updates the price and the
     "whole bean · 250 g" line on the card and in the sheet.

  2. PDP sticky Add bar (snippets/broot-sticky-atc.liquid). Its button submits
     the REAL product form through the HTML `form="…"` attribute, so no JS is
     involved in the add itself. Here we (a) show/hide the bar once the real
     Add button has scrolled out of view and the cart drawer is closed, (b)
     mirror the selected variant TITLE and the theme's live price into it, and
     (c) mirror the real button's disabled / sold-out state.
*/
(function () {
  if (window.__brootQuickLoaded) return;
  window.__brootQuickLoaded = true;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /* The chooser link is hidden in CSS until this class exists, so a page that
     never loaded this file (or has JS off) shows no dead link. */
  document.documentElement.classList.add('broot-quick-js');

  /* ---------------------------------------------------------------- */
  /* 1. Card chooser                                                   */
  /* ---------------------------------------------------------------- */

  function variantsOf(root) {
    if (root.__brootVariants) return root.__brootVariants;
    var list = [];
    var tag = root.querySelector('script[data-broot-variants]');
    if (tag) {
      try {
        list = JSON.parse(tag.textContent) || [];
      } catch (e) {
        list = [];
      }
    }
    root.__brootVariants = list;
    return list;
  }

  function currentSelection(root) {
    var sel = [];
    var rows = root.querySelectorAll('.broot-quick__row');
    for (var i = 0; i < rows.length; i++) {
      var idx = parseInt(rows[i].getAttribute('data-i'), 10);
      var chip = rows[i].querySelector('.broot-quick__chip.is-selected');
      sel[idx] = chip ? chip.getAttribute('data-value') : null;
    }
    return sel;
  }

  function matches(variant, sel) {
    for (var i = 0; i < sel.length; i++) {
      if (sel[i] != null && variant.o[i] !== sel[i]) return false;
    }
    return true;
  }

  // Exact combination if it is purchasable; otherwise keep the option that was
  // just tapped and move the others to the closest purchasable combination.
  function resolve(variants, sel, tappedIndex) {
    var exact = null;
    for (var i = 0; i < variants.length; i++) {
      if (matches(variants[i], sel)) {
        exact = variants[i];
        break;
      }
    }
    if (exact && exact.a) return exact;
    var best = null;
    var bestScore = -1;
    variants.forEach(function (v) {
      if (!v.a) return;
      if (tappedIndex != null && v.o[tappedIndex] !== sel[tappedIndex]) return;
      var score = 0;
      sel.forEach(function (val, idx) {
        if (val != null && v.o[idx] === val) score++;
      });
      if (score > bestScore) {
        best = v;
        bestScore = score;
      }
    });
    return best || exact;
  }

  function each(root, selector, fn) {
    var list = root.querySelectorAll(selector);
    for (var i = 0; i < list.length; i++) fn(list[i]);
  }

  function paint(root, variant) {
    each(root, '.broot-quick__row', function (row) {
      var idx = parseInt(row.getAttribute('data-i'), 10);
      each(row, '.broot-quick__chip', function (chip) {
        var on = !!variant && variant.o[idx] === chip.getAttribute('data-value');
        chip.classList.toggle('is-selected', on);
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
    var idInput = root.querySelector('.broot-quick__variant-id');
    var summaryEl = root.querySelector('[data-broot-summary]');
    var ok = !!variant && !!variant.a;
    if (variant && idInput) idInput.value = variant.id;
    if (variant && summaryEl) summaryEl.textContent = variant.o.join(' \u00b7 ');
    if (variant) {
      each(root, '[data-broot-price]', function (el) {
        el.textContent = variant.p;
      });
    }
    // the card's Add and the sheet's Add are the same button twice
    each(root, '.broot-quick__add', function (btn) {
      btn.disabled = !ok;
      btn.classList.toggle('is-sold-out', !ok);
    });
    each(root, '.broot-quick__add-label', function (el) {
      el.classList.toggle('hidden', !ok);
    });
    each(root, '.broot-quick__add-sold-out', function (el) {
      el.classList.toggle('hidden', ok);
    });
  }

  // A chip is disabled only when NO purchasable variant carries that value.
  function markSoldOut(root) {
    var variants = variantsOf(root);
    var chips = root.querySelectorAll('.broot-quick__chip');
    for (var i = 0; i < chips.length; i++) {
      var row = chips[i].closest('.broot-quick__row');
      var idx = parseInt(row.getAttribute('data-i'), 10);
      var val = chips[i].getAttribute('data-value');
      var any = false;
      for (var v = 0; v < variants.length; v++) {
        if (variants[v].a && variants[v].o[idx] === val) {
          any = true;
          break;
        }
      }
      chips[i].classList.toggle('is-disabled', !any);
      if (any) chips[i].removeAttribute('aria-disabled');
      else chips[i].setAttribute('aria-disabled', 'true');
    }
  }

  // Reflect the dialog's real state on the card (caret, aria-expanded).
  function syncOpen(root) {
    var panel = root.querySelector('.broot-quick__panel');
    var more = root.querySelector('.broot-quick__more');
    var open = !!panel && panel.hasAttribute('open');
    root.classList.toggle('is-open', open);
    if (more) more.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function setOpen(root, open) {
    var panel = root.querySelector('.broot-quick__panel');
    if (!panel) return;
    if (open) {
      markSoldOut(root);
      if (typeof panel.showModal === 'function') {
        if (!panel.open) panel.showModal();
      } else {
        panel.setAttribute('open', ''); // very old browsers: plain, non-modal
      }
    } else if (typeof panel.close === 'function') {
      if (panel.open) panel.close();
    } else {
      panel.removeAttribute('open');
    }
    syncOpen(root);
  }

  document.addEventListener('click', function (evt) {
    var t = evt.target;
    if (!t || !t.closest) return;
    var more = t.closest('.broot-quick__more');
    if (more) {
      var host = more.closest('[data-broot-quick]');
      if (host) setOpen(host, !host.classList.contains('is-open'));
      return;
    }
    // the dialog's own box is only ever the target when the backdrop is tapped
    var panel = t.classList.contains('broot-quick__panel') ? t : null;
    var closeBtn = t.closest('.broot-sheet__close');
    if (panel || closeBtn) {
      var owner = t.closest('[data-broot-quick]');
      if (owner) setOpen(owner, false);
      return;
    }
    var chip = t.closest('.broot-quick__chip');
    if (!chip) return;
    if (chip.classList.contains('is-disabled')) return;
    var root = chip.closest('[data-broot-quick]');
    var row = chip.closest('.broot-quick__row');
    if (!root || !row) return;
    var tapped = parseInt(row.getAttribute('data-i'), 10);
    var sel = currentSelection(root);
    sel[tapped] = chip.getAttribute('data-value');
    paint(root, resolve(variantsOf(root), sel, tapped));
  });

  // Escape / dialog.close() fire "close" (it does not bubble, so capture it)
  document.addEventListener(
    'close',
    function (evt) {
      var root = evt.target && evt.target.closest && evt.target.closest('[data-broot-quick]');
      if (root) syncOpen(root);
    },
    true
  );

  // Tapping the sheet's Add: hand focus back to the card's Add and close the
  // sheet first, so the theme's product-form.js (which runs next) sees the card
  // as the active element and any stock error appears on the card.
  document.addEventListener(
    'submit',
    function (evt) {
      var root = evt.target && evt.target.closest && evt.target.closest('[data-broot-quick]');
      if (!root || !root.classList.contains('is-open')) return;
      var add = root.querySelector('.broot-quick__add');
      setOpen(root, false);
      if (add && add.focus) add.focus({ preventScroll: true });
    },
    true
  );

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Escape') return;
    var open = document.querySelector('[data-broot-quick].is-open');
    if (!open) return;
    setOpen(open, false);
    var more = open.querySelector('.broot-quick__more');
    if (more) more.focus();
  });

  /* ---------------------------------------------------------------- */
  /* 2. PDP sticky Add bar                                             */
  /* ---------------------------------------------------------------- */

  function readPrice(node) {
    if (!node) return '';
    var sale = node.querySelector('.price--on-sale .price__sale .price-item--sale');
    var el =
      sale ||
      node.querySelector('.price__regular .price-item--regular') ||
      node.querySelector('.price-item');
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function initStickyBar() {
    var bar = document.querySelector('[data-broot-sticky-atc]');
    if (!bar) return;

    // Section ids on a JSON template are generated ("template--123__main"), so
    // the ids the layout hard-codes into the bar may not exist. Fall back to the
    // theme's own classes: the real Add button, its form and the price block.
    var target =
      document.getElementById(bar.getAttribute('data-watch') || '') ||
      document.querySelector('.product-form__submit[id^="ProductSubmitButton-"]');
    if (!target) return; // no buy box on this page: the bar stays hidden
    var priceSource =
      document.getElementById(bar.getAttribute('data-price-source') || '') ||
      document.querySelector('.product__info-container .price-wrapper');
    var priceTarget = bar.querySelector('[data-broot-sticky-price]');
    var variantTarget = bar.querySelector('[data-broot-sticky-variant]');
    var stickyBtn = bar.querySelector('[data-broot-sticky-btn]');
    var cartDrawer = document.querySelector('cart-drawer');
    var drawerOpen = false;
    var pastButton = false;

    // the bar's button submits the REAL form through the `form` attribute.
    // (getAttribute, not .id: the form has an <input name="id">, which shadows
    // the form's own id property.)
    var realForm = target.form || target.closest('form');
    var realFormId = realForm && realForm.getAttribute('id');
    if (realFormId && stickyBtn) stickyBtn.setAttribute('form', realFormId);

    function render() {
      bar.classList.toggle('is-visible', pastButton && !drawerOpen);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          // "scrolled past" = the real button is above the viewport, not merely
          // not reached yet
          pastButton = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          render();
        },
        { threshold: 0 }
      );
      io.observe(target);
    }

    function syncPrice() {
      if (!priceTarget || !priceSource) return;
      var text = readPrice(priceSource);
      if (text) priceTarget.textContent = text;
    }

    function syncVariant() {
      if (!variantTarget) return;
      var picker = document.querySelector('variant-radios');
      if (!picker) return;
      var checked = picker.querySelectorAll('input[type="radio"]:checked');
      var vals = [];
      for (var i = 0; i < checked.length; i++) vals.push(checked[i].value);
      if (vals.length) variantTarget.textContent = vals.join(' \u00b7 ');
    }

    function syncButton() {
      if (!stickyBtn) return;
      var off = target.hasAttribute('disabled');
      stickyBtn.disabled = off;
      var span = target.querySelector('span');
      stickyBtn.textContent = off ? (span && span.textContent.trim()) || 'Sold out' : 'Add';
    }

    if (priceSource && priceTarget && 'MutationObserver' in window) {
      new MutationObserver(syncPrice).observe(priceSource, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
    if (stickyBtn && 'MutationObserver' in window) {
      new MutationObserver(syncButton).observe(target, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    // The theme swaps the price in after a fetch; re-read shortly after each
    // pick as a belt-and-braces to the observer above.
    document.addEventListener('change', function (evt) {
      var t = evt.target;
      if (!t || !t.closest || !t.closest('variant-radios')) return;
      syncVariant();
      window.setTimeout(syncPrice, 350);
      window.setTimeout(syncPrice, 900);
      window.setTimeout(syncButton, 500);
    });

    if (cartDrawer && 'MutationObserver' in window) {
      new MutationObserver(function () {
        drawerOpen = cartDrawer.classList.contains('active');
        render();
      }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  ready(initStickyBar);
})();